import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabase";

const modules = [
  {
    to: "/admin/indicateurs",
    label: "Chiffres clés",
    description: "Gérez les indicateurs affichés sur la page d'accueil.",
    icon: "ri-bar-chart-line",
  },
  {
    to: "/admin/parametres",
    label: "Infos générales",
    description: "Coordonnées, réseaux sociaux et textes du site.",
    icon: "ri-settings-3-line",
  },
  {
    to: "/admin/missions",
    label: "Missions",
    description: "Les cartes « Nos missions » de la page d'accueil.",
    icon: "ri-heart-3-line",
  },
  {
    to: "/admin/arguments",
    label: "Arguments",
    description: "Les raisons de nous soutenir.",
    icon: "ri-chat-smile-3-line",
  },
  {
    to: "/admin/equipe",
    label: "Équipe",
    description: "Les membres de l'équipe de l'association.",
    icon: "ri-team-line",
  },
  {
    to: "/admin/historique",
    label: "Historique",
    description: "Les grandes étapes de l'association.",
    icon: "ri-history-line",
  },
  {
    to: "/admin/valeurs",
    label: "Valeurs",
    description: "Les valeurs fondamentales de l'association.",
    icon: "ri-shield-check-line",
  },
  {
    to: "/admin/mission",
    label: "Notre mission",
    description: "Le texte de présentation et les piliers.",
    icon: "ri-flag-line",
  },
  {
    to: "/admin/actions",
    label: "Actions",
    description: "Les domaines d'action de l'association.",
    icon: "ri-hand-heart-line",
  },
  {
    to: "/admin/realisations",
    label: "Réalisations",
    description: "Les événements et actions passées.",
    icon: "ri-image-line",
  },
  {
    to: "/admin/faq",
    label: "FAQ des dons",
    description: "Les questions fréquentes de la page don.",
    icon: "ri-questionnaire-line",
  },
  {
    to: "/admin/dons",
    label: "Réglages des dons",
    description: "Montants, points de confiance et impact.",
    icon: "ri-money-euro-circle-line",
  },
  {
    to: "/admin/membres",
    label: "Membres",
    description: "Invitez et gérez les comptes de l'équipe.",
    icon: "ri-user-settings-line",
  },
];

export default function AdminDashboard() {
  const [fullName, setFullName] = useState("");

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) {
        const meta = data.session.user.user_metadata as { full_name?: string };
        setFullName(meta?.full_name ?? "");
      }
    });
  }, []);

  return (
    <div className="p-6 md:p-10">
      <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
        {fullName ? `Bonjour, ${fullName}` : "Bonjour"}
      </h1>
      <p className="mt-2 text-sm md:text-base text-foreground-600">
        Bienvenue dans votre espace de gestion. Choisissez une section pour
        commencer.
      </p>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {modules.map((mod) => (
          <Link
            key={mod.to}
            to={mod.to}
            className="bg-background-50 rounded-lg border border-background-200 p-5 md:p-6 hover:border-primary-300 transition cursor-pointer"
          >
            <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className={`${mod.icon} text-xl`}></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
              {mod.label}
            </h3>
            <p className="mt-1 text-sm text-foreground-600">{mod.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}